export const RoundStatus = {
  upcoming: 0,
  started: 1,
  finished: 2,
  canceled: 3,
  onFinish: 4,
  open: 5,
  onHold: 6,
};
